function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
/* eslint-disable no-param-reassign */
/**
 * localStorage方法封装
 */
var LStorage = {
  set: function set(key, value) {
    if (!value) {
      value = '';
    }
    if (_typeof(value) === 'object' || typeof value === 'function') {
      value = JSON.stringify(value);
    }
    return localStorage.setItem(key, value);
  },
  get: function get(key) {
    var value = localStorage.getItem(key);
    if (!value) {
      return null;
    }
    try {
      var obj = JSON.parse(value);
      return obj;
    } catch (error) {
      return value;
    }
  },
  remove: function remove(key) {
    localStorage.removeItem(key);
  },
  clear: function clear() {
    localStorage.clear();
  }
};
export default LStorage;